<div class="demo-full-width margin-top" [formGroup]="group">
  @switch (buttonType) {
    @case (field.img) {
      <ion-button
        (click)="handleClick($event)"
        type="submit"
        color="primary"
        shape="round"
      >
        <img [src]="field.img" [alt]="field.label" />
      </ion-button>
    }
    @default {
      <ion-button
        (click)="handleClick($event)"
        type="submit"
        color="primary"
        expand="block"
      >
        {{ field.label }}
      </ion-button>
    }
  }
</div>
